<template>
  <takeover>
    <sign-in-form />
  </takeover>
</template>



<script>
  import { mapState } from 'vuex';

  export default {
    name: 'SignIn',

    metaInfo() {
      return { title: 'Sign In' };
    },

    computed: {
      ...mapState('session', ['isSignedIn'])
    },

    watch: {
      isSignedIn: 'handleSignInChange'
    },

    mounted() {
      if (this.isSignedIn) {
        this.handleSignInChange(true);
      }
    },

    methods: {
      handleSignInChange(isSignedIn) {
        if (isSignedIn) {
          // Check for Stream parameters
          if (this.$route.query.stream_client_id && this.$route.query.stream_redirect_uri) {
            // Redirect to stream consent page with parameters
            this.$router.replace({
              name: 'streamConsent',
              query: {
                clientId: this.$route.query.stream_client_id,
                responseType: this.$route.query.stream_response_type,
                redirectUri: this.$route.query.stream_redirect_uri
              }
            });
          }
          else {
            this.$router.replace({ name: 'home' });
          }
        }
      }
    }
  };
</script>
